/* eslint-disable react-hooks/exhaustive-deps */
import { reportApis } from 'Api/reports';
import { PermissionContext } from 'components/Global/AuthLayout';
import Buttons from 'components/Global/Buttons';
import { TablePagination, TableSorter } from 'interfaces/global.interface';
import { useContext, useEffect, useState } from 'react';
import { toastText } from 'utils/utils';
import GlobalReportTable from '../GlobalReportTable';
import GeneratePayrollSummaryModal from './GeneratePayrollSummaryModal';
import Styles from './index.module.scss';

const PayrollSummaryReportComponent = () => {
	const [totalRecords, setTotalRecords] = useState(0);
	const [isLoading, setIsLoading] = useState(false);
	const [currentPage, setCurrentPage] = useState(1);
	const [pageSize, setPageSize] = useState(10);
	const [sortField, setSortField] = useState('');
	const [sortOrder, setSortOrder] = useState('');
	const [modalOpen, setModalOpen] = useState(false);
	const [payrollSummaryData, setPayrollSummaryData] = useState<any[]>([]);

	const context = useContext(PermissionContext);
	const check = context.allowedPermissions.includes('Add_Payroll_Reports');

	const buttons = [
		{
			text: 'Generate',
			isLoading: false,
			className: 'btn-blue',
			// icon: <AddSvg />,
			isSubmit: true,
			onclick: () => {
				setModalOpen(true);
			},
			disabled: isLoading,
		},
	];

	const tableChangeHandler = (
		pagination: TablePagination,
		filters: any,
		sorter: TableSorter
	) => {
		setTotalRecords(pagination.total);
		setCurrentPage(pagination.current);
		setPageSize(pagination.pageSize);
		let order = '';
		if (sorter?.order === 'ascend') {
			order = 'asc';
		} else if (sorter?.order) {
			order = 'desc';
		}
		setSortOrder(order);
		setSortField(sorter.field);
	};

	const cancelModal = () => {
		setModalOpen(false);
	};

	const fetchPayrollSummaryReports = async () => {
		try {
			const query = {
				page: currentPage,
				sortBy: sortField,
				sortOrder: sortOrder,
				pageSize: pageSize,
			};
			setIsLoading(true);
			const payrollSummaryData =
				await reportApis.getPayrollSummaryReports(query);
			setPayrollSummaryData(payrollSummaryData.data.data);
			setTotalRecords(payrollSummaryData.data.total);
		} catch (err: any) {
			const errorMessage =
				err?.response?.data?.message ||
				'Something went wrong in fetching payroll summary reports.';
			toastText(errorMessage, 'error');
		} finally {
			setIsLoading(false);
		}
	};

	useEffect(() => {
		fetchPayrollSummaryReports();
	}, [currentPage, sortField, sortOrder, pageSize]);

	return (
		<>
			<div className={Styles['container']}>
				<div className={Styles['payroll-summary-header']}>
					{check && <Buttons buttons={buttons} />}
				</div>
				<GlobalReportTable
					ReportData={payrollSummaryData}
					isLoading={isLoading}
					tableChangeHandler={tableChangeHandler}
					totalRecords={totalRecords}
					pageSize={pageSize}
					currentPage={currentPage}
				  isCurrency={true}
				/>
			</div>
			{modalOpen && (
					<GeneratePayrollSummaryModal
						open={modalOpen}
						cancelGenerateModal={cancelModal}
						fetchPayrollSummaryDetails={fetchPayrollSummaryReports}
					/>
			)}
		</>
	);
};

export default PayrollSummaryReportComponent;
